import React from "react";
import styled from "styled-components";
import SpinnerBase from "./SpinnerBase";
import colours from "../../lib/colours";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colours.th1l1};
`;

const spinnerStyle = {
  display: "flex",
  alignItems: "center",
  marginLeft: "6px",
  width: "30px",
};

const spinnerChildrenStyle = {
  width: "8px",
  height: "8px",
};

interface IProps {
  message: string;
}

function ProgressMessage({ message }: IProps) {
  return (
    <Container>
      <span>{message}</span>
      <SpinnerBase style={spinnerStyle} childrenStyle={spinnerChildrenStyle} />
    </Container>
  );
}

export default ProgressMessage;
